import React from "react"

import PropTypes from "prop-types"

import * as styles from "./main.module.scss"

const Main = ({ children, color, fullscreen }) => {
  let type = "regular"
  if (fullscreen) type = "fullscreen"

  return (
    <main
      id="#main"
      className={`${styles.main} ${styles[`main__${type}`]} ${
        color ? styles[`main__${color.replace("-", "")}`] : ""
      }`}
      tabIndex="-1"
    >
      {fullscreen ? (
        ""
      ) : (
        <div className={`lngtd_dynamic_leaderboard ${styles.ad}`} />
      )}
      {children}
    </main>
  )
}

export default Main

Main.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  fullscreen: PropTypes.bool,
}

Main.defaultProps = {
  color: "",
  fullscreen: false,
}
